import type {
  CreateStaffAccountInput,
  StaffAccountListDto,
  StaffAccountWithInvitationDto,
} from '@icebreaker/shared/staff';
import { api } from '@/shared/api/client';

/**
 * PERSONEL HESAPLARI — `api` katmanı, YALNIZCA sagalardan çağrılır (eslint
 * `no-api-in-ui`). Altı uç da `/panel/staff*` altındadır ve yalnız
 * `staff:account_manage` taşıyan personel (admin) çağırabilir.
 *
 * Davet yanıtında JETON YOKTUR (`StaffInvitationDto`): bağlantı yalnız
 * e-postaya gider. Ekran bu yüzden "gönderildi + son kullanma" cümlesi kurar,
 * bağlantıyı asla göstermez.
 */

export async function fetchStaffAccounts(): Promise<StaffAccountListDto> {
  return await api.staff.accounts();
}

export async function inviteStaff(
  input: CreateStaffAccountInput,
): Promise<StaffAccountWithInvitationDto> {
  return await api.staff.createAccount(input);
}

/** Yeniden davet — kilitlenen personelin TEK kurtarma yolu (Karar 4c). */
export async function reinviteStaff(
  staffAccountId: string,
): Promise<StaffAccountWithInvitationDto> {
  return await api.staff.reinvite(staffAccountId);
}

export async function cancelStaffInvitation(staffAccountId: string): Promise<void> {
  await api.staff.cancelInvitation(staffAccountId);
}

export async function suspendStaff(staffAccountId: string): Promise<void> {
  await api.staff.suspendAccount(staffAccountId);
}

export async function unsuspendStaff(staffAccountId: string): Promise<void> {
  await api.staff.unsuspendAccount(staffAccountId);
}
